/* generated using openapi-typescript-codegen -- do not edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
/**
 * Coverage details for a single group including staffing metrics
 */
export type shifts_GroupCoverageDTO = {
    baby_count?: number;
    child_count?: number;
    coverage_percent?: number;
    group_id?: string;
    group_name?: string;
    group_type?: string;
    min_qualified_staff?: number;
    non_baby_count?: number;
    /**
     * QualifiedShortfall is true when scheduled qualified staff is below min_qualified_staff (threshold model)
     */
    qualified_shortfall?: boolean;
    required_staff?: number;
    /**
     * ScheduledQualifiedStaff is the count of scheduled employees with qualification_level QUALIFIED
     */
    scheduled_qualified_staff?: number;
    scheduled_staff?: number;
    staffing_model?: string;
    status?: shifts_GroupCoverageDTO.status;
    weighted_child_count?: number;
};
export namespace shifts_GroupCoverageDTO {
    export enum status {
        SUFFICIENT = 'SUFFICIENT',
        WARNING = 'WARNING',
        CRITICAL = 'CRITICAL',
        NO_CHILDREN = 'NO_CHILDREN',
        NOT_CONFIGURED = 'NOT_CONFIGURED',
    }
}

